export default {
  sections: {
    business_info: 'Informações da empresa',
    bank_info: 'Informações bancárias',
  },
  form: {
    company_name: {
      label: 'Nome do restaurante',
      placeholder: 'Nome do restaurante',
    },
    business_name: {
      label: 'Nome da empresa',
      placeholder: 'Nome da empresa',
    },
    owner_full_name: {
      label: 'Nome do proprietário',
      placeholder: 'Nome do proprietário',
    },
    business_address: {
      label: 'Morada da empresa',
      placeholder: 'Morada da empresa',
    },
    business_zip_code: {
      label: 'Código postal da empresa',
      placeholder: 'Código postal da empresa',
    },
    business_city: {
      label: 'Cidade da empresa',
      placeholder: 'Cidade da empresa',
    },
    business_country: {
      label: 'País da empresa',
      options: {
        DE: 'Alemanha',
        GB: 'Reino Unido',
        US: 'Estados Unidos',
      },
    },
    company_phone_number: {
      label: 'Número de telefone do restaurante',
      placeholder: 'Número de telefone do restaurante',
    },
    contact_person_full_name: {
      label: 'Nome do contacto',
      placeholder: 'Nome do contacto',
    },
    contact_person_phone_number: {
      label: 'Número de telefone do contacto',
      placeholder: 'Número de telefone do contacto',
    },
    contact_person_email: {
      label: 'E-mail do contacto',
      placeholder: 'E-mail do contacto',
    },
    business_bank_account_holder_name: {
      label: 'Nome do titular da conta bancária',
      placeholder: 'Nome do titular da conta bancária',
    },
    business_bank_account_number: {
      label: 'Número de conta bancária',
      placeholder: 'DE01101234567891234567',
    },
    business_bank_routing_number: {
      label: 'Número de roteamento bancário',
      placeholder: '110000000',
    },
    business_tax_id: {
      label: 'NIF da empresa',
      placeholder: 'NIF da empresa',
    },
  },
};
